import { States } from "./states";
import { Districts } from "./districts";
import { StateDivisions } from "./divisions";
import { Cities } from "./cities";
import { Banks } from "./banksList";
import { IndiaState } from "./indiaState";
import { statecityData } from "./statecityData";
import { itiCoursesList } from "./itiCoursesList";
export {
  States,
  Districts,
  StateDivisions,
  Cities,
  Banks,
  IndiaState,
  statecityData,
  itiCoursesList,
};
